module.exports = __webpack_public_path__ + "img/cj@2x.10bafc52.png";